


























import { GeekProfileAchievement } from '@/models/geek-profile';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'AchievementsTab',
  computed: {
    achievements(): GeekProfileAchievement[] {
      return typedStore(this).state.achievements.geeksAchievements;
    },
  },
  methods: {
    getAchievementTooltipText(achievement: GeekProfileAchievement): string {
      return achievement.reason
        ? this.getAchievementGrantedWithReasonTooltip(achievement)
        : this.getAchievementGrantedTooltip(achievement);
    },
    getAchievementGrantedTooltip(achievement: GeekProfileAchievement): string {
      return this.$t(
        'geek-profile.achievements-tab.achievement-granted',
        {
          date: (this as any).$options.filters.formattedDate(achievement.date),
        },
      ) as string;
    },
    getAchievementGrantedWithReasonTooltip(achievement: GeekProfileAchievement): string {
      return this.$t(
        'geek-profile.achievements-tab.achievement-granted-reason',
        {
          date: (this as any).$options.filters.formattedDate(achievement.date),
          reason: achievement.reason,
        },
      ) as string;
    },
  },
});
